import { businessData } from "data/businessData";
import styled from "styled-components";
import styles from "./businessGrid.module.css";
import SvgBusiness from "./svgBusiness";

const StyledGridRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Grid = () => {
  return (
    <section className={styles.home_one__section_main}>
      <div className={styles.home_one__wrapper}>
        <StyledGridRow>
          {businessData.grid.map((obj) => {
            return (
              <div key={obj.text} className={styles.home_one__block}>
                <div className={styles.home_one__section}>
                  <SvgBusiness name={obj.icon} />
                  <label className={styles.home_one__label}>{obj.text}</label>
                </div>
              </div>
            );
          })}
        </StyledGridRow>
      </div>
    </section>
  );
};

export default Grid;
